import { Component, HostListener, NgZone, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import {
  NavigationItem,
  navigationItemsNoPatient,
} from '../../models/navigation-item-model';
import { Router, RouterModule } from '@angular/router';
import { classes, pages } from '../../shared/labels';
import { LabelService } from '../../services/label.service';
import { DoctorService } from '../../services/doctor.service';
import {
  CalendarPatient,
  Patient,
  PatientNames,
  Reminders,
  TodayAppointments,
} from '../../models/patient-model';
import { PatientService } from '../../services/patient.service';
import { CommonModule } from '@angular/common';
import { CalendarEvent } from 'angular-calendar';
import { EventColor } from 'calendar-utils';
import { CalendarGoogle } from '../../models/doctor-model';
import {
  CalendarEventWithGoogleEventId,
  modifyCalendarEvent,
  newCalendarEvent,
} from '../../models/calendar-model';
import { lastValueFrom } from 'rxjs';
import { ErrorPanelService } from '../../services/error-panel.service';
import { MatIconModule } from '@angular/material/icon';
import { TodayAppointmentsService } from './today-appointments.service';
import { DbAppointmentsService } from './db-appointments.service';
import {
  AppointmentReadCollectionResource,
  AppointmentUpdate,
} from '../../models/appointment-model';
import { CalendarAdapterService } from './calendar-adapter.service';
import { GoogleCalendarService } from './google-calendar.service';
import { CalendarOrchestratorService } from './calendar.orchestrator.service';
import { CalendarUtilsService } from './calendar-utils.service';
@Component({
  selector: 'app-calendar-page',
  standalone: true,
  imports: [SharedModule, RouterModule, CommonModule, MatIconModule],
  templateUrl: './calendar-page.component.html',
  styleUrl: './calendar-page.component.scss',
})
export class CalendarPageComponent implements OnInit {
  navigationItems: NavigationItem[] = navigationItemsNoPatient;
  eventsAllCalendars: any = [];
  todayDate: Date = new Date();
  allPatients: CalendarPatient[] = [];
  nextPatient!: CalendarPatient;
  remindersNextPatient: Reminders[] = [];
  nextPatientName: string = '';
  nextPatientSurname: string = '';
  nextPatientId: string = '';
  showNewCalendarEventPanel: boolean = false;
  showModifyCalendarEventPanel: boolean = false;
  loadedEvents: boolean = false;
  angularCalendarEvents: CalendarEvent[] = [];
  gCalPsicogeniusEvents: CalendarEvent[] = [];
  calendarsGoogle: CalendarGoogle[] = [];

  newAppointmentDay: string = '';
  newAppointmentMonth: string = '';
  newAppointmentYear: string = '';
  newAppointmentHours: string = '';
  newAppointmentMinutes: string = '';
  newAppointmentDate: string = '';
  newAppointmentTime: string = '';

  modifyAppointmentTitle: string = '';
  modifyAppointmentDay: string = '';
  modifyAppointmentMonth: string = '';
  modifyAppointmentYear: string = '';
  modifyAppointmentStartHours: string = '';
  modifyAppointmentStartMinutes: string = '';
  modifyAppointmentEndHours: string = '';
  modifyAppointmentEndMinutes: string = '';
  modifyAppointmentDate: string = '';
  modifyAppointmentStartTime: string = '';
  modifyAppointmentEndTime: string = '';
  modifyAppointmentId: string = '';
  modifyAppointmentCalendarId: string = '';
  modifyPsicogeniusId: string = '';
  modifyAppointmentContainsGoogleEvent: boolean = true;
  isAppointmentModifiable: boolean = true;
  modifyTitleCard: string = '';
  selectedModifyAppoinment: any;

  isAppointmentAllDay: boolean = false;

  clineaseEventsWithGCalEventId: CalendarEventWithGoogleEventId[] = [];
  clineaseEventsEmptyGCalEventId: CalendarEventWithGoogleEventId[] = [];
  dbAppointments: AppointmentReadCollectionResource[] = [];

  colors: Record<string, EventColor> = {
    blue: {
      primary: '#B8D8FF',
      secondary: '#B8D8FF',
    },
    blue_deleted: {
      primary: '#FF7074',
      secondary: '#B8D8FF',
    },
  };

  doctorPatients: PatientNames[] = [];

  isMobile = window.innerWidth < 930;

  get todayAppointments() {
    return this.todayAppointmentsService.todayAppointments;
  }

  get nextPatientFullName() {
    return this.todayAppointmentsService.nextPatientFullName;
  }

  get remindersNotCompleted() {
    return this.todayAppointmentsService.remindersNotCompleted;
  }

  constructor(
    public labelService: LabelService,
    private doctorService: DoctorService,
    private patientService: PatientService,
    public errorPanelService: ErrorPanelService,
    private zone: NgZone,
    private todayAppointmentsService: TodayAppointmentsService,
    private dbAppointmentsService: DbAppointmentsService,
    private calendarAdapterService: CalendarAdapterService,
    private googleCalendarService: GoogleCalendarService,
    private calendarOrchestratorService: CalendarOrchestratorService,
    private calendarUtilsService: CalendarUtilsService
  ) {
    // highlight the correct page in the side bar
    this.navigationItems = navigationItemsNoPatient.map((item) => {
      if (item.label === pages.calendar) {
        return { ...item, class: classes.hb };
      }
      return { ...item };
    });
  }

  ngOnInit(): void {
    this.todayAppointmentsService.getTodayAppointments();
    this.getAllPatients();
  }

  // start of todayAppointments code
  changePatient(appointment: TodayAppointments) {
    this.todayAppointmentsService.changePatient(appointment);
  }

  navigateToPatientPage() {
    this.todayAppointmentsService.navigateToPatientPage();
  }

  navigateToAiPatientPage() {
    this.todayAppointmentsService.navigateToAiPatientPage();
  }

  navigateToLastAppointmentSummaryPage() {
    this.todayAppointmentsService.navigateToLastAppointmentSummaryPage(
      this.dbAppointments
    );
  }
  // end of todayAppointments code

  getAllPatients() {
    this.allPatients = [];
    this.doctorService.getAllPatients().subscribe({
      next: (data) => {
        if (data) {
          data.map((patient: Patient) => {
            this.allPatients.push(patient);
            this.allPatients = this.allPatients.sort((a, b) =>
              a.last_name.localeCompare(b.last_name)
            );
          });
        }
        this.populateEvents();
      },
      error: (err) => {
        console.error('Errore nel recupero dei pazienti', err);
        this.errorPanelService.showErrorSnackBar(
          'Errore nel recupero dei pazienti. Ti chiediamo di rieffettuare il login.'
        );
      },
    });
  }

  populateEvents() {
    this.angularCalendarEvents = [];
    this.gCalPsicogeniusEvents = [];
    // TODO: understand if clineaseEvents is necessary
    this.clineaseEventsWithGCalEventId = [];
    this.clineaseEventsEmptyGCalEventId = [];
    this.loadedEvents = false;
    this.doctorService.getAllAppointments().subscribe({
      next: (data: AppointmentReadCollectionResource[]) => {
        this.dbAppointments = data;
        if (data) {
          data.map((appointment: AppointmentReadCollectionResource) => {
            const patient = this.allPatients.find(
              (patient) => patient.id === appointment.patient_id
            );
            const calendarEvent =
              this.calendarAdapterService.adapterFromDbAppointmentToAngularCalendarEvent(
                appointment,
                patient!
              );
            this.angularCalendarEvents.push(calendarEvent);
            const calendarEventWithGoogleEventId: CalendarEventWithGoogleEventId =
              {
                ...calendarEvent,
                google_calendar_event_id: appointment.google_calendar_event_id,
                id: appointment.id! as string,
              };
            if (calendarEventWithGoogleEventId.google_calendar_event_id) {
              this.clineaseEventsWithGCalEventId.push(
                calendarEventWithGoogleEventId
              );
            } else {
              this.clineaseEventsEmptyGCalEventId.push(
                calendarEventWithGoogleEventId
              );
            }
          });
        }
        this.countPatientAppointments();
      },
      error: (err) => {
        console.error(
          'Errore nel recuperare gli appuntamenti del professionista',
          err
        );
        this.errorPanelService.showErrorSnackBar(
          'Errore nel recuperare gli appuntamenti del professionista'
        );
      },
    });
    const token = sessionStorage.getItem('googleAccessToken');
    if (token) {
      this.loadCalendarsAndEvents(token);
    }
  }
  // FIXME:fetch google events when changing the months
  loadCalendarsAndEvents(token: string) {
    this.googleCalendarService.loadCalendars(token).then((calendars) => {
      this.calendarsGoogle = calendars.map((calendar) => ({
        id: calendar.id,
        backgroundColor: calendar.backgroundColor,
        summary: calendar.summary,
        role: calendar.accessRole,
      }));

      const promises = calendars.map((calendar) => {
        return this.googleCalendarService
          .loadEventsStartingFromPreviousMonth(token, calendar.id)
          .then((googleEvents) => {
            const events = googleEvents.map((event) =>
              this.calendarAdapterService.adapterFromGCalEventToAngularCalendarEvent(
                event,
                calendar.backgroundColor
              )
            );

            // if the event is in the psicogenius calendar it is already added in the angularCalendarEvents, i just add it to the gCalPsicogeniusEvents
            events.forEach((event) => {
              if (
                calendar.id === sessionStorage.getItem('PsicogeniusCalendarId')
              ) {
                this.gCalPsicogeniusEvents.push(event);
              } else {
                this.angularCalendarEvents.push(event);
              }
            });
          });
      });

      Promise.all(promises).then(() => {
        this.zone.run(() => {
          this.loadedEvents = true;
        });
      });
    });
  }

  countPatientAppointments() {
    this.allPatients.map((patient) => {
      patient.count =
        this.dbAppointments.filter((app) => app.patient_id === patient.id)
          .length + 1;
    });
  }

  toggleNewEventPanel(event?: any) {
    if (event) {
      this.newAppointmentDay = event.date.getDate().toString().padStart(2, '0');
      this.newAppointmentMonth = (event.date.getMonth() + 1)
        .toString()
        .padStart(2, '0');
      this.newAppointmentYear = event.date.getFullYear().toString();
      this.newAppointmentHours = event.date
        .getHours()
        .toString()
        .padStart(2, '0');
      this.newAppointmentMinutes = event.date
        .getMinutes()
        .toString()
        .padStart(2, '0');
    } else {
      this.newAppointmentDay = '';
      this.newAppointmentMonth = '';
      this.newAppointmentYear = '';
      this.newAppointmentHours = '';
      this.newAppointmentMinutes = '';
    }
    this.showNewCalendarEventPanel = !this.showNewCalendarEventPanel;
  }

  addNewEvent(newEvent: newCalendarEvent) {
    this.calendarOrchestratorService.addNewEvent(newEvent).then((response) => {
      this.showNewCalendarEventPanel = !this.showNewCalendarEventPanel;
      this.populateEvents();
      if (newEvent.isAppointment && this.isToday(response.date)) {
        this.todayAppointmentsService.getTodayAppointments();
      }
    });
  }

  isToday(dateString: string): boolean {
    const today = new Date();
    const todayString = `${today.getDate().toString().padStart(2, '0')}/${(
      today.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}/${today.getFullYear()}`;
    return dateString === todayString;
  }

  toggleModifyPanel(event?: CalendarEvent) {
    if (event) {
      this.selectedModifyAppoinment = event;
      this.modifyTitleCard = 'Modifica Evento';
      this.isAppointmentAllDay = event.allDay ? event.allDay : false;
      this.modifyAppointmentCalendarId =
        this.calendarsGoogle.find(
          (calendar) => calendar.backgroundColor === event.color?.primary
        )?.id || '';
      this.isAppointmentModifiable =
        this.calendarsGoogle.find(
          (calendar) => calendar.id === this.modifyAppointmentCalendarId
        )?.role === 'reader'
          ? false
          : true;
      this.modifyAppointmentTitle = event.title;
      this.modifyAppointmentDay = event.start
        .getDate()
        .toString()
        .padStart(2, '0');
      this.modifyAppointmentMonth = (event.start.getMonth() + 1)
        .toString()
        .padStart(2, '0');
      this.modifyAppointmentYear = event.start.getFullYear().toString();
      this.modifyAppointmentStartHours = event.start
        .getHours()
        .toString()
        .padStart(2, '0');
      this.modifyAppointmentStartMinutes = event.start
        .getMinutes()
        .toString()
        .padStart(2, '0');
      if (event.end) {
        this.modifyAppointmentEndHours = event.end
          .getHours()
          .toString()
          .padStart(2, '0');
        this.modifyAppointmentEndMinutes = event.end
          .getMinutes()
          .toString()
          .padStart(2, '0');
      }
      if (event.id) {
        this.modifyAppointmentId = event.id.toString();
      }
      // if true the event does not have a google calendar event id
      if (event.color?.primary === this.colors['blue_deleted'].primary) {
        this.modifyAppointmentContainsGoogleEvent = false;
      }
      // se non ha trovato un calendario è un evento psicogenius, quindi devo prendere l'appuntamento dal db
      if (this.modifyAppointmentCalendarId === '') {
        this.patientService.getAppointment(this.modifyAppointmentId).subscribe({
          next: (response) => {
            this.modifyTitleCard = event.title.includes(':')
              ? event.title.split(':', 2)[0]
              : 'Modifica Evento';
            this.modifyAppointmentTitle = response.title;
            this.modifyAppointmentId = response.google_calendar_event_id || '';
            this.modifyPsicogeniusId = response.id;
            this.modifyAppointmentCalendarId =
              sessionStorage.getItem('PsicogeniusCalendarId') || '';
            this.showModifyCalendarEventPanel =
              !this.showModifyCalendarEventPanel;
          },
          error: (err) => {
            console.error('Errore nel recuperare appuntamento', err);
            this.errorPanelService.showErrorSnackBar(
              "Errore nel recuperare l'appuntamento"
            );
          },
        });
      }
      // if the event is in a google calendar not psicogenius, i just show the modify panel
      else {
        this.showModifyCalendarEventPanel = !this.showModifyCalendarEventPanel;
      }
    } else {
      this.modifyAppointmentCalendarId = '';
      this.modifyAppointmentDay = '';
      this.modifyAppointmentMonth = '';
      this.modifyAppointmentYear = '';
      this.modifyAppointmentStartHours = '';
      this.modifyAppointmentStartMinutes = '';
      this.modifyAppointmentEndHours = '';
      this.modifyAppointmentEndMinutes = '';
      this.modifyPsicogeniusId = '';
      this.showModifyCalendarEventPanel = !this.showModifyCalendarEventPanel;
      this.modifyAppointmentContainsGoogleEvent = true;
      this.isAppointmentAllDay = false;
      this.selectedModifyAppoinment = {};
      this.isAppointmentModifiable = true;
    }
  }

  modifyCalendarEvent(modifyEvent: modifyCalendarEvent) {
    this.showModifyCalendarEventPanel = false;

    if (this.modifyPsicogeniusId !== '') {
      const data = {
        date: modifyEvent.date,
        start_time: modifyEvent.start_time,
        end_time: modifyEvent.end_time,
        title: modifyEvent.title,
      };

      const updateDb = () => {
        this.dbAppointmentsService
          .updateAppointmentInDb(this.modifyPsicogeniusId, data)
          .then((response) => {
            this.populateEvents();
            if (this.isToday(response.date)) {
              this.todayAppointmentsService.getTodayAppointments();
            }
          });
      };

      if (!this.modifyAppointmentContainsGoogleEvent) {
        updateDb();
      } else {
        this.googleCalendarService
          .modifyCalendarEvent(modifyEvent, this.modifyAppointmentCalendarId)
          .then(() => {
            updateDb();
          });
      }
    }
    // enters here if the event is not a psicogenius appointment
    else {
      this.googleCalendarService
        .modifyCalendarEvent(modifyEvent, this.modifyAppointmentCalendarId)
        .then(() => {
          this.populateEvents();
        });
    }
  }

  deleteCalendarEvent(eventId: string) {
    if (!this.modifyAppointmentContainsGoogleEvent) {
      if (this.modifyPsicogeniusId !== '') {
        this.dbAppointmentsService
          .deleteAppointmentFromDb(
            this.modifyPsicogeniusId,
            this.selectedModifyAppoinment?.title
          )
          .then(() => {
            this.showModifyCalendarEventPanel =
              !this.showModifyCalendarEventPanel;
            this.populateEvents();
          });
      }
    } else {
      this.googleCalendarService
        .deleteCalendarEvent(eventId, this.modifyAppointmentCalendarId)
        .then(() => {
          this.showModifyCalendarEventPanel =
            !this.showModifyCalendarEventPanel;
          if (this.modifyPsicogeniusId !== '') {
            this.dbAppointmentsService
              .deleteAppointmentFromDb(
                this.modifyPsicogeniusId,
                this.selectedModifyAppoinment?.title
              )
              .then(() => {
                this.populateEvents();
              });
          } else {
            this.populateEvents();
          }
        });
    }
  }

  // update the appointments in the db with the changes in the google calendar.
  // create new appointments, update existing ones and handle delete
  async synchAppointments() {
    const allOperations: any[] = [];

    // Process create and put
    this.gCalPsicogeniusEvents.forEach((psicogeniusEvent) => {
      const index = this.clineaseEventsWithGCalEventId.findIndex(
        (appointment) =>
          appointment.google_calendar_event_id === psicogeniusEvent.id
      );

      if (index !== -1) {
        const temp_appointment = this.clineaseEventsWithGCalEventId[index];
        this.clineaseEventsWithGCalEventId.splice(index, 1);

        if (
          psicogeniusEvent.title !== temp_appointment.title ||
          psicogeniusEvent.start.getTime() !==
            temp_appointment.start.getTime() ||
          psicogeniusEvent.end?.getTime() !== temp_appointment.end?.getTime()
        ) {
          const updateAppointmentPromise = this.updateAppointment(
            psicogeniusEvent,
            temp_appointment
          );
          allOperations.push(updateAppointmentPromise);
        }
      } else {
        const createAppointmentPromise =
          this.createAppointment(psicogeniusEvent);
        allOperations.push(createAppointmentPromise);
      }
    });

    // Process delete
    this.clineaseEventsWithGCalEventId.forEach((appointment) => {
      const psicogeniusAppointment = this.gCalPsicogeniusEvents.find(
        (psicogeniusEvent) =>
          psicogeniusEvent.id === appointment.google_calendar_event_id
      );
      if (!psicogeniusAppointment) {
        const deleteAppointmentOperation = lastValueFrom(
          // FIXME: the null is ignored by the backend.
          this.patientService.putAppointment(appointment.id, {
            google_calendar_event_id: '', // FIXME: this is a temporary fix: '' should be null. the real solution is to accept null instead of empty  string. make sure the backend correctly handles it.
          })
        );
        allOperations.push(deleteAppointmentOperation);
      }
    });

    // Wait for all operations to complete then call ngOnInit
    Promise.all(allOperations)
      .then(() => {
        this.ngOnInit();
      })
      .catch((error) => {
        console.error('Error during synchronization of appointments:', error);
        this.errorPanelService.showErrorSnackBar(
          'Errore durante la sincronizzazione degli appuntamenti'
        );
      });
  }

  async updateAppointment(
    psicogeniusEvent: CalendarEvent<any>,
    temp_appointment: { id: string }
  ) {
    const objForPutAppointment: AppointmentUpdate =
      this.calendarAdapterService.adapterFromAngularCalendarEventToDbAppointmentForUpdate(
        psicogeniusEvent
      );

    try {
      const response = await lastValueFrom(
        this.patientService.putAppointment(
          temp_appointment.id,
          objForPutAppointment
        )
      );
    } catch (error) {
      console.error('Errore:', error);
      this.errorPanelService.showErrorSnackBar(
        `Errore nell'aggiornare l'appuntamento ${psicogeniusEvent.title}`
      );
    }
  }

  async createAppointment(psicogeniusEvent: CalendarEvent<any>) {
    if (
      !psicogeniusEvent.title ||
      !psicogeniusEvent.title.includes(':') ||
      psicogeniusEvent.title.includes('(PAZIENTE NON ESISTENTE)')
    ) {
      return;
    }

    let name = psicogeniusEvent.title.split(':')[0];

    try {
      const patient = this.allPatients.find(
        (p) =>
          `${p.first_name} ${p.last_name}`.toLowerCase() === name.toLowerCase()
      );
      if (!patient) {
        throw new Error(`Patient not found: ${name}`);
      }

      const newAppointmentObj =
        this.calendarAdapterService.adapterFromAngularCalendarEventToDbAppointmentForCreate(
          psicogeniusEvent,
          patient.id
        );

      const createResponse = await lastValueFrom(
        this.patientService.createAppointment(newAppointmentObj)
      );

      return createResponse;
    } catch (error) {
      // Create a new title indicating the patient doesn't exist
      const newTitle = `${psicogeniusEvent.title} (PAZIENTE NON ESISTENTE)`;

      // Update the event in Google Calendar using the adapter
      await this.googleCalendarService.modifyCalendarEvent(
        this.calendarAdapterService.adapterFromAngularCalendarEventToGoogleCalendarModify(
          psicogeniusEvent,
          newTitle
        ),
        sessionStorage.getItem('PsicogeniusCalendarId') || ''
      );

      console.error("Errore nella creazione dell'appuntamento:", error);
      this.errorPanelService.showErrorSnackBar(
        `Impossibile creare l'appuntamento per ${name}. Verificare che il paziente esista nel sistema.`
      );
      throw error;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 930;
  }
}
